exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var getUrl = require("../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL___0___ = getUrl(require("../assets/main-bg@3x.png"));
// Module
exports.push([module.id, ".index-page.b2b2c-header-bg {\n  background-image: url(" + ___CSS_LOADER_URL___0___ + ") !important;\n}\n.landing-bottom-img {\n  position: absolute;\n  bottom: 0;\n}\n", ""]);
